import pdfMake from 'addthaifont-pdfmake';
import 'addthaifont-pdfmake/build/vfs_fonts';
import buddhistEra from 'dayjs/plugin/buddhistEra';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';
import dayjs from 'dayjs';
import _ from 'lodash';
import THBText from 'thai-baht-text';

pdfMake.fonts = {
  Sarabun: {
    normal: 'Sarabun-Light.ttf',
    bold: 'Sarabun-Regular.ttf',
    italics: 'Sarabun-LightItalic.ttf',
    bolditalics: 'Sarabun-Italic.ttf',
  },
};
dayjs.locale('th');
dayjs.extend(buddhistEra);
dayjs.extend(LocalizedFormat);

const billGoldReport = async (data) => {
  const formatCurrency = (value) => {
    const formatter = new Intl.NumberFormat('th-TH', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    return (value < 0 ? '- ' : '') + formatter.format(Math.abs(value));
  };

  const cashCheck = data?.payment?.cash?.status === true;
  const transferCheck = data?.payment?.transfer?.status === true;
  const creditCheck = data?.payment?.credit?.status === true;

  const bankDetails =
    data?.payment?.transfer?.bank?.name +
    ' ' +
    data?.payment?.transfer?.bank?.accountNumber;

  const content = [];

  // สร้างฟังก์ชันสำหรับ header table
  const createTableHeader = (order) => [
    [
      {
        text: 'วันที่',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: dayjs(data?.date).format('DD MMMM BBBB เวลา HH:MM'),
        alignment: 'left',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      { text: '', border: [false, false, false, false] },
      {
        text: 'ราคาทองแท่งขายออก',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.price_gold || 0),
        alignment: 'center',
        border: [true, true, true, true],
      },
      { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
    ],
    [
      {
        text: 'เลขที่',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: dayjs(data?.date).format('DD-MM-BBBB') + ' -AV02',
        alignment: 'left',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      { text: '', border: [false, false, false, false] },
      {
        text: 'ราคาทองรูปพรรณซื้อคืนต่อบาท',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.pricebackperbath || 0),
        alignment: 'center',
        border: [true, true, true, true],
      },
      { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
    ],
    [
      { text: '', border: [false, false, false, false], colSpan: 4 },
      {},
      {},
      {},
      {
        text: 'ราคาทองรูปพรรณซื้อคืนต่อกรัม',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.pricebackpergram || 0),
        alignment: 'center',
        border: [true, true, true, true],
      },
      { text: 'บาท', alignment: 'center', border: [true, true, true, true] },
    ],
    [
      {
        text: 'รายการสินค้า',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 3,
      },
      {},
      {},
      {
        text: 'น้ำหนัก(กรัม)',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'จำนวน',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'ราคาต่อหน่วย',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'รวมจำนวนเงิน(บาท)',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
  ];

  // สร้างฟังก์ชันสำหรับ summary rows
  const createSummaryRows = (order) => [
    [
      { text: '', border: [false, false, false, false] },
      {
        text: 'รวมน้ำหนักสุทธิ(กรัม)',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.weight || 0),
        alignment: 'right',
        border: [true, true, true, true],
      },
      {
        text: 'รวมจำนวนเงินสุทธิ(บาท)',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.cost || 0),
        alignment: 'right',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
    [
      { text: '', border: [false, false, false, false], colSpan: 4 },
      {},
      {},
      {},
      {
        text: 'ราคาสินค้าก่อนภาษีมูลค่าเพิ่ม',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.totalbeforeVat || 0),
        alignment: 'right',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
    [
      {
        text: cashCheck ? 'x' : ' ',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'เงินสด',
        alignment: 'center',
        border: [true, true, true, true],
      },
      { text: '', border: [false, false, false, false], colSpan: 2 },
      {},
      {
        text: 'หักราคาทองรูปพรรณซื้อคืน',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.baseTotalVat || 0),
        alignment: 'right',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
    [
      {
        text: creditCheck ? 'x' : ' ',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'บัตรเครดิต',
        alignment: 'center',
        border: [true, true, true, true],
      },
      { text: '', border: [false, false, false, false], colSpan: 2 },
      {},
      {
        text: 'ส่วนต่างฐานภาษี',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.baseVat || 0),
        alignment: 'right',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
    [
      {
        text: transferCheck ? 'x' : ' ',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: 'ธนาคาร',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: bankDetails || '',
        alignment: 'left',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: 'ภาษีมูลค่าเพิ่ม',
        alignment: 'center',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
      {
        text: formatCurrency(order?.vat || 0),
        alignment: 'right',
        border: [true, true, true, true],
        colSpan: 2,
      },
      {},
    ],
    [
      { text: '', border: [false, false, false, false], colSpan: 3 },
      {},
      {},
      {
        text: 'ตัวอักษร',
        alignment: 'center',
        border: [true, true, true, true],
      },
      {
        text: THBText(order?.cost || 0),
        alignment: 'left',
        border: [true, true, true, true],
        colSpan: 4,
      },
      {},
      {},
      {},
    ],
    [
      { text: '', border: [false, false, false, false], colSpan: 5 },
      {},
      {},
      {},
      {},
      {
        text: '\nผู้รับเงิน......................................',
        alignment: 'right',
        border: [false, false, false, false],
        colSpan: 3,
      },
      {},
      {},
    ],
  ];

  // วนลูปสร้างแต่ละหน้าสำหรับแต่ละรายการ
  data?.order?.forEach((order, index) => {
    const tableHeader = createTableHeader(order);

    // สร้างแถวสำหรับรายการนี้
    const itemRow = [
      {
        text: order?.material?.name || '',
        alignment: 'center',
        border: [true, false, false, false],
        colSpan: 2,
      },
      {},
      {
        text: order?.material?.material_type?.name || '',
        alignment: 'right',
        border: [false, false, false, false],
      },
      {
        text: (order?.weight || 0).toFixed(2),
        alignment: 'right',
        border: [true, false, true, false],
      },
      {
        text: (order?.quantity || 0).toString(),
        alignment: 'right',
        border: [true, false, true, false],
      },
      {
        text: (order?.cost || 0).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        alignment: 'right',
        border: [true, false, true, false],
      },
      {
        text: (order?.cost || 0).toLocaleString('en-US', {
          minimumFractionDigits: 2,
          maximumFractionDigits: 2,
        }),
        alignment: 'right',
        border: [true, false, true, false],
        colSpan: 2,
      },
      {},
    ];

    // สร้างแถวว่างเพื่อเติมพื้นที่
    const emptyRows = [];
    for (let i = 0; i < 10; i++) {
      emptyRows.push([
        { text: '', border: [true, false, true, false], colSpan: 3 },
        {},
        {},
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false] },
        { text: '', border: [true, false, true, false], colSpan: 2 },
        {},
      ]);
    }

    // แถวปิดตาราง
    const closingRow = [
      { text: '', border: [true, false, true, true], colSpan: 3 },
      {},
      {},
      { text: '', border: [true, false, true, true] },
      { text: '', border: [true, false, true, true] },
      { text: '', border: [true, false, true, true] },
      { text: '', border: [true, false, true, true], colSpan: 2 },
      {},
    ];

    const summaryRows = createSummaryRows(order);

    // รวมทุกส่วนเข้าด้วยกัน
    const fullTableBody = [
      ...tableHeader,
      itemRow,
      ...emptyRows,
      closingRow,
      ...summaryRows,
    ];

    const pageTable = {
      margin: [0, 12],
      table: {
        headerRows: 0,
        widths: ['10%', '*', '*', 'auto', 'auto', 'auto', 'auto', 'auto'],
        body: fullTableBody,
      },
    };

    content.push(pageTable);

    // เพิ่ม page break ถ้าไม่ใช่หน้าสุดท้าย
    if (index < data?.order?.length - 1) {
      content.push({ text: '', pageBreak: 'after' });
    }
  });

  const documentRef = {
    pageSize: 'A5',
    pageOrientation: 'landscape',
    pageMargins: [40, 80, 40, 20],
    defaultStyle: {
      font: 'Sarabun',
      fontSize: '9',
    },
    info: {
      title: 'Report',
    },
    header: [
      {
        text: [
          '\n\n\nห้างหุ้นส่วนจำกัด ห้องทองอัญญรัตน์ (สำนักงานใหญ่)\n',
          'เลขประจำตัวผู้เสียภาษี 090 3559 003 191\n',
          'ใบเสร็จรับเงิน/ใบกำกับภาษีอย่างย่อ',
        ],
        style: {
          style: 'header',
          alignment: 'center',
          bold: true,
        },
      },
    ],
    content: content,
    styles: {
      headerPage: {
        fontSize: 14,
        bold: true,
        alignment: 'center',
      },
      header: {
        fontSize: 11,
        bold: true,
        alignment: 'center',
      },
      header2: {
        bold: true,
      },
    },
    footer: function (currentPage, pageCount) {
      return {
        text: currentPage + ' / ' + pageCount,
        alignment: 'center',
        fontSize: 8,
        margin: [0, 0, 0, 10],
      };
    },
  };

  pdfMake.createPdf(documentRef).open();
};

export default billGoldReport;
